import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

import {
  Header,
  Footer,
  NotFound,
  Private,
  Editor,
} from './components';

import {
  Dashboard,
  LessonDetails,
  NewVideo,
  UpdateVideo,
} from './pages';
import { useDispatch } from 'react-redux';
import { setUserDetails } from './lib/features/userReducer';
import { useEffect } from 'react';
import axios from 'axios';
import Cookies from 'js-cookie';
import { jwtDecode } from "jwt-decode";

import { useJwt } from "react-jwt";
import { BASE_URL } from './constants';

axios.defaults.withCredentials = true;

const App = () => {
  const { decodedToken, isExpired, reEvaluateToken } = useJwt(Cookies.get("access_token"));
  const dispatch = useDispatch();

  useEffect(() => {
    const token = Cookies.get("access_token");
    let decodedToken = {};
    if (!token) {

      axios.get(`${BASE_URL}/auth/login.php`).then(res => {

        decodedToken = jwtDecode(token || "");

        dispatch(setUserDetails(decodedToken?.data));
      }).catch((error) => {
        console.log("here from error ")
        NavigateToLogin();
      });

    } else {


      // if(pathname.search("parentmeetings")===-1)

      // initConeection( SOCKETURL , token );

      decodedToken = jwtDecode(token || "");

      axios.post(`${BASE_URL}/auth/updateroles.php`, {
        username: decodedToken.data.userName,
      }).then((res) => {
        if (res.data.data !== null && res.data.data !== undefined && res.data.data.jwt !== null && res.data.data.jwt !== false) {

          // console.log(res.data.data.jwt)
          decodedToken = jwtDecode(res.data.data.jwt || "");

          dispatch(setUserDetails(decodedToken.data));

        } else {
          // NavigateToLogin();
        }
      })



      return;



    }
  }, [])


  const NavigateToLogin = () => {
    window.location.replace(`${BASE_URL}/auth/login_lms.php` ?? "");
  };

  return (
    <Router>
      <main className='app'>
        {window.location.href.includes("lessonsview") ? null : (<Header />)}

        <div className='min-h-[80vh]'>
          <Routes>
            <Route element={<Private />}>
              <Route path='/' exact element={<Navigate to="/dashboard/video" />} />
              <Route path='/dashboard' exact element={<Navigate to="/dashboard/video" />} />
              <Route path='/dashboard/:type' exact element={<Dashboard library={0} />} />
              <Route path='/dashboard/:type/library' element={<Dashboard library={1} />} />
              <Route path='/lessons/:id' element={<LessonDetails />} />
              <Route path='/lessonsview/:id' element={<LessonDetails />} />
              <Route path='/lessonsviewsl/:id' element={<LessonDetails />} />
            </Route>

            <Route element={<Editor />}>
              <Route path='/new-video' element={<NewVideo />} />
              <Route path='/update-video/:id' element={<UpdateVideo />} />
            </Route>

            <Route path="*" element={<NotFound />} />
          </Routes>
        </div>
        {window.location.href.includes("lessonsview") ? null : (<Footer />)}

      </main>
    </Router>
  )
}

export default App